<template>
   <div class="change-history-c" :class="oldsegments ? 'is-oldsegments' : ''">
      <table>
         <thead>
            <tr>
               <th>{{ $t("changeHistoryTable_thFlightNo") }}</th>
               <th>{{ $t("changeHistoryTable_thRoute") }}</th>
               <th>{{ $t("changeHistoryTable_thFrom") }}</th>
               <th>{{ $t("changeHistoryTable_thTo") }}</th>
               <th>{{ $t("changeHistoryTable_thDeparture") }}</th>
               <th>{{ $t("changeHistoryTable_thArrival") }}</th>
               <th>{{ $t("changeHistoryTable_thCabinType") }}</th>
               <th>{{ $t("changeHistoryTable_thClass") }}</th>
               <th>{{ $t("changeHistoryTable_thBrandCode") }}</th>
               <th>{{ $t("changeHistoryTable_thBrandName") }}</th>
               <th>{{ $t("changeHistoryTable_thMarketingOperating") }}</th>
            </tr>
         </thead>

         <tbody>
            <tr v-for="(row, index) in rows" :key="index">
               <td :class="row.flightNumber.hasChanged ? 'highlight' : ''">{{ row.flightNumber.value }}</td>
               <td :class="row.flightRoute.hasChanged ? 'highlight' : ''">{{ row.flightRoute.value }}</td>
               <td :class="row.segmentRoute.hasChanged ? 'highlight' : ''">{{ row.departureAirportCode.value }}</td>
               <td :class="row.segmentRoute.hasChanged ? 'highlight' : ''">{{ row.arrivalAirportCode.value }}</td>
               <td :class="row.departureDateTime.hasChanged ? 'highlight' : ''">{{ row.departureDateTime.value | FormatterDD_MM_YYYY_HH_mm }}</td>
               <td :class="row.arrivalDateTime.hasChanged ? 'highlight' : ''">{{ row.arrivalDateTime.value | FormatterDD_MM_YYYY_HH_mm }}</td>
               <td :class="row.cabinType.hasChanged ? 'highlight' : ''">{{ row.cabinType.value | EFltCabinType }}</td>
               <td :class="row.flightClass.hasChanged ? 'highlight' : ''">{{ row.flightClass.value }}</td>
               <td :class="row.brandCode.hasChanged ? 'highlight' : ''">{{ row.brandCode.value }}</td>
               <td :class="row.brandName.hasChanged ? 'highlight' : ''">{{ row.brandName.value }}</td>
               <td :class="row.marketingAirlineCode.hasChanged ? 'highlight' : ''">{{ row.marketingAirlineCode.value }}</td>
            </tr>
         </tbody>
      </table>
   </div>
</template>

<script>
export default {
   name: "ChangeHistory",
   props: {
      rows: {
         type: Array,
         required: true,
      },
      oldsegments: Boolean,
      changes: [Object, Array],
   },
};
</script>

<style lang="scss" scoped>
$delayed-color: var(--green-600);
$table-border-color: var(--gray-300);
$table-header-bg: var(--leaf-100);
$table-padding: 10px;

.change-history-c {
   margin: 1rem 0;
   overflow: hidden;
   border-top-left-radius: 0.5rem;
   border-top-right-radius: 0.5rem;

   &.is-oldsegments {
      opacity: 0.7;
      font-size: 0.85rem;
      table {
         th {
            background-color: var(--gray-200);
         }
         td {
            &.highlight {
               font-weight: normal;
               color: var(--gray-800);
               text-decoration: line-through;
            }
         }
      }
   }

   table {
      width: 100%;
      border-collapse: collapse;
      text-align: left;

      th {
         background-color: $table-header-bg;
         padding: $table-padding;
         font-weight: 500;
      }

      td {
         padding: $table-padding;
         border: 1px solid $table-border-color;

         &.highlight {
            color: $delayed-color;
            font-weight: bold;
         }
      }
   }
}
</style>
